import { isNativeApp } from './platform.js';

export async function hapticLight() {
  if (!isNativeApp()) return;
  try {
    const { Haptics, ImpactStyle } = await import('@capacitor/haptics');
    await Haptics.impact({ style: ImpactStyle.Light });
  } catch {
    try {
      navigator.vibrate?.(10);
    } catch {
      /* ignore */
    }
  }
}

export async function hapticMedium() {
  if (!isNativeApp()) return;
  try {
    const { Haptics, ImpactStyle } = await import('@capacitor/haptics');
    await Haptics.impact({ style: ImpactStyle.Medium });
  } catch {
    try {
      navigator.vibrate?.(16);
    } catch {
      /* ignore */
    }
  }
}

export async function hapticSelection() {
  if (!isNativeApp()) return;
  try {
    const { Haptics } = await import('@capacitor/haptics');
    await Haptics.selectionChanged();
  } catch {
    try {
      navigator.vibrate?.(8);
    } catch {
      /* ignore */
    }
  }
}
